import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";

export default function OfferSlider() {
  return (
    <div className="bg-black text-white text-center">
        <style>
            {`
            .offer-text{
  font-size:12px;
  letter-spacing:0.5px;
}
            `}
        </style>
      <Swiper
        modules={[Autoplay]}
        direction="vertical"
        slidesPerView={1}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        style={{ height: "40px" }}
      >
        <SwiperSlide className="d-flex offer-text justify-content-center align-items-center">
          🚚 FREE SHIPPING ABOVE 149 AED
        </SwiperSlide>

        <SwiperSlide className="d-flex offer-text justify-content-center align-items-center">
          ✨ FREE CASH ON DELIVERY
        </SwiperSlide>

        <SwiperSlide className="d-flex offer-text justify-content-center align-items-center">
          ⚡ EXCHANGE AND RETURN POLICY
        </SwiperSlide>
      </Swiper>

      
    </div>
  );
}